import type { PluginListenerHandle} from '@capacitor/core';
import { WebPlugin } from '@capacitor/core';

import type { SumsubMobileSdkPlugin, SumsubSdkStatus } from './definitions';

export class SumsubMobileSdkWeb extends WebPlugin implements SumsubMobileSdkPlugin {
  async initialize(): Promise<{ status: SumsubSdkStatus }> {
    throw this.unimplemented('Not implemented on web.');
  }

  async present(): Promise<void> {
    throw this.unimplemented('Not implemented on web.');
  }

  async dismiss(): Promise<void> {
    throw this.unimplemented('Not implemented on web.');
  }

  async setAccessToken(): Promise<void> {
    throw this.unimplemented('Not implemented on web.');
  }

  async getVerificationStatus(): Promise<{ status: SumsubSdkStatus }> {
    throw this.unimplemented('Not implemented on web.');
  }

  async addListener(): Promise<PluginListenerHandle> {
    throw this.unimplemented('Not implemented on web.');
  }
}
